import { Box } from '@mui/material';
import { infoContainerSx, infoSectionSx } from '../../styles/Global.style';

export const SecureHandlingPolicy = () => (
  <Box component="div" sx={infoSectionSx}>
    <Box component="div" sx={infoContainerSx}>
      <p>
        <strong>BALJAFFRAY PRIMARY SCHOOL PARENT-TEACHER ASSOCIATION</strong>
      </p>
      <p>
        <strong>
          Secure Handling of Disclosure Information Guidance and Policy
        </strong>
      </p>
      <p>
        The purpose of this policy is to provide guidance and instruction on how
        to appropriately handle disclosures for those who will have access to
        them and to provide assurance to Volunteer Scotland Disclosure Services
        and our members and volunteers that their disclosure information will be
        handled, used, stored and destroyed appropriately and in accordance with
        the Disclosure Scotland Code of Practice.
      </p>
      <p>
        For the purpose of this policy, PVG Scheme Disclosures and Level 2
        Disclosures issued from 1 April 2025 onwards and PVG Scheme Records and
        PVG Short Scheme Records, Standard disclosures and Enhanced disclosures
        issued prior to 1 April 2025 will be referred to as disclosures.
      </p>
      <p>
        This policy is for organisations enrolled with Volunteer Scotland
        Disclosure Services to access disclosures for the purpose of assessing
        individual&rsquo;s suitability for paid and/or voluntary work.
      </p>
      <p>
        In accordance with the Disclosure Scotland Code of Practice, for
        registered persons and other recipients of disclosure information, we
        will ensure the following practice.
      </p>
      <p>
        <strong>Requesting Disclosures</strong>
      </p>
      <p>
        Disclosures will only be requested when necessary and relevant to a
        particular post and the information provided on a disclosure will only
        be used for recruitment purposes.
      </p>
      <p>
        Our organisation will ensure that an individual&rsquo;s consent is given
        before seeking a disclosure. Before using disclosure information for any
        other purpose, we will seek their consent and will take advice from VSDS
        to ensure it is appropriate to use the disclosure for a purpose other
        than recruitment. Furthermore, we will ensure that all sensitive
        personal information that is collated for the purposes of obtaining a
        disclosure will be always managed confidentially by those involved in
        the disclosure process.
      </p>
      <p>
        We will not request disclosure information for other organisations
        without first discussing the appropriate process and receiving approval
        for this from VSDS.
      </p>
      <p>
        <strong>Sharing Information</strong>
      </p>
      <p>
        We will only share disclosure information with those authorised to see
        it in the course of their duties.&nbsp;
      </p>
      <p>
        <strong>Storage</strong>
      </p>
      <p>
        Disclosure information will be stored in secure conditions as follows:-
      </p>
      <p>
        <strong>Online Results </strong>
      </p>
      <p>
        A note will be taken of any vetting information which needs to be
        reviewed. Access to disclosure information will be restricted to those
        that are entitled to see it in the course of their duties. When
        receiving an online result, it is essential that we record the
        information required for our Disclosure Tracking Record.
      </p>
      <p>
        No photocopy or other image of the disclosure information will be
        retained.
      </p>
      <p>
        <strong>Paper Disclosures</strong>
      </p>
      <p>
        Paper documents will be kept in lockable and non-portable storage units.
        Access to disclosure information will be restricted to those that are
        entitled to see it in the course of their duties.
      </p>
      <p>
        No photocopy or other image of the disclosure information will be
        retained.
      </p>
      <p>
        <strong>Telephone Results</strong>
      </p>
      <p>
        When receiving disclosure information by telephone, VSDS staff will only
        convey information detailed in disclosures accessed by our organisation
        to our enrolled signatories once they have correctly answered the
        relevant security questions.
      </p>
      <p>
        Failing to provide the correct answers to the required security
        questions will result in VSDS withholding the required information and
        may lead to an investigation being carried out to establish why our
        enrolled signatory was unable to provide the required security
        information. Once the disclosure information has been shared with us,
        VSDS will shred the disclosure.
      </p>
      <p>
        VSDS does not keep a record of any information contained on the
        disclosure. When receiving a telephone result, it is essential that we
        record the information required for our Disclosure Tracking Record.
      </p>
      <p>
        <strong>Emailed Certificates</strong>
      </p>
      <p>
        VSDS ceased emailing disclosures on 10 June 2024, this section is only
        required for organisations that received disclosures by email and stored
        those email disclosures.
      </p>
      <p>
        Care will be taken in relation to emailed disclosure information, and we
        will endeavour to prevent unauthorised viewing, transmission, storage,
        printing or fraudulent manipulation.
      </p>
      <p>
        Access to email disclosures will be restricted to those who are entitled
        to see it in the course of their duties.
      </p>
      <p>
        Insert details here of how you will store email disclosure records here:
        (this should be copied from the last version of your Secure Handling
        Policy).
      </p>
      <p>
        No photocopy or other image of the disclosure information will be
        retained.
      </p>
      <p>
        <strong>Record Keeping</strong>
      </p>
      <p>
        It is our organisations responsibility to keep accurate information
        about disclosures we have accessed. The following information will be
        recorded on our Disclosure Tracking Record:
      </p>
      <ul>
        <li>Name of Applicant</li>
        <li>Date of Birth</li>
        <li>Level of Disclosure</li>
        <li>Position applied for</li>
        <li>Signatory</li>
        <li>Date Posted/requested online</li>
        <li>Date Processed (application requests only)</li>
        <li>T Reference Number</li>
        <li>Date disclosure issued</li>
        <li>Certificate/Disclosure Number</li>
        <li>PVG Membership Number</li>
        <li>Date Destroyed/Deleted</li>
        <li>Recruitment Decision and date</li>
      </ul>
      <p>
        We will not record whether there was any vetting information as the Code
        of Practice prohibits this. VSDS provides a sample tracking document in
        the guidance and resources section of their website.
      </p>
      <p>
        <strong>Retention</strong>
      </p>
      <p>
        We will not retain disclosures for longer than is necessary for the
        purpose for which the disclosure record was obtained. PVG disclosures
        will be destroyed securely on receipt of an updated PVG disclosure, and
        they will not be retained beyond the last day that a scheme member is
        carrying out regulated work for our organisation.
      </p>
      <p>
        <strong>Destruction/Deletion</strong>
      </p>
      <p>
        We will take reasonable steps to ensure that disclosure information is
        destroyed by suitable and secure means, for example, shredding, pulping
        or burning. Electronic images from email certificates will also be
        deleted permanently from both the email address where it was received
        and from where it is stored.
      </p>
      <p>
        We will ensure that all members with access to disclosure information
        are aware of this policy and have received training and support to help
        them to comply with both this policy and the code of practice. A copy of
        this policy will be made available to any applicant, members or
        volunteer who requests it.
      </p>
      <p>
        <strong>Lost Disclosures</strong>
      </p>
      <p>
        If we lose a physical or emailed copy of a disclosure or any other
        record of disclosure information, we will notify the scheme member(s)
        affected, VSDS and the Information Commissioners Office.
      </p>
      <p>
        <strong>Code of Practice</strong>
      </p>
      <p>
        Further instructions and guidance on secure handling of disclosure
        information can be found in sections 3 and 12 of the Code of Practice.
      </p>
    </Box>
  </Box>
);
